<template>
    <div>
        <div class="row">
            <div class="col-12">
                <b-card
                    class="shadow-sm"
                    header-bg-variant=""
                    header-text-variant="black"
                >                    
                    <template v-slot:header>
                        <div class="d-flex justify-content-between align-items-center">
                            <h5 class="mb-0">Details</h5>
                            <div v-if="canEdit">
                                <b-button 
                                    v-if="editMode" 
                                    key="save" 
                                    size="sm" 
                                    variant="success" 
                                    class="mr-2" 
                                    @click="updateItemForm"
                                >
                                    Save
                                </b-button>
                                <b-button 
                                    v-if="!editMode" 
                                    key="edit" 
                                    size="sm" 
                                    variant="sharp-primary" 
                                    @click="enterEditMode"
                                >
                                    <b-icon icon="pencil" class="mr-2"></b-icon>
                                    Edit
                                </b-button>
                                <b-button 
                                    v-else-if="editMode" 
                                    key="cancel" 
                                    size="sm" 
                                    variant="secondary" 
                                    @click="cancelEditMode"
                                >
                                    Cancel
                                </b-button>
                            </div>
                            
                        </div>
                    </template>

                    <product-detail-form
                        ref="productDetailForm"
                        :item-pk="itemPk"
                        class=""
                        @edit-on="editMode = true"
                        @edit-off="editMode = false"
                    ></product-detail-form>

                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import ProductDetailForm from './ProductDetailForm';
import { currentUserInfoMixin, tenantInfoMixin } from "../js/custom-vue-mixins";

export default {
    name: 'ProductDetailCard',
    components: {
        ProductDetailForm,
    },
    mixins: [
        currentUserInfoMixin,
        tenantInfoMixin,
    ],
    props: {
        itemPk: {
            type: [Number, String],
            required: false,
        },
    },
    data: function() {
        return {
            editMode: false,
        }
    },
    computed: {
        canEdit() {
            if (this.$getTenantFlag('allow_any_internal_write_products', false)) {
                // check tenant flag for now... in future, we will have actual permissions
                return this.$currentUserInfo?.is_internal || false;
            }
            return this.$currentUserInfo?.is_paid_seat || false;
        },
    },
    methods: {
        enterEditMode: function() {
            // set local edit mode and call cancelEditMode on child form
            this.editMode = true;
            this.$refs.productDetailForm.enterEditMode();
        },
        cancelEditMode: function() {
            // set local edit mode and call cancelEditMode on child form
            this.editMode = false;
            this.$refs.productDetailForm.cancelEditMode();
        },
        updateItemForm: function() {
            // call update method on child form
            // no need to set local editMode value here... let events from child component set that
            // but make sure you watch for them with @edit-on and @edit-off
            this.$refs.productDetailForm.updateItemData();
        }
    }
}
</script>

<style>

</style>